import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactUsComponent implements OnInit {
  mainTitle = 'Contact Us'

  constructor() {}

  ngOnInit(): void {}
}
